import { render, staticRenderFns } from "./HistoryDataGadai.vue?vue&type=template&id=20f842a4&"
import script from "./HistoryDataGadai.vue?vue&type=script&lang=js&"
export * from "./HistoryDataGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports